export const dataHooks = {
    chevronRight: 'sidebar-submenu-chevron-right',
    sidebarItem: 'sidebar-item',
    submenu: 'submenu',
    submenuPopover: 'submenu-popover',
    suffix: 'sidebar-sub-menu-chevron',
    divider: 'divider',
    sidebarTitleItem: 'sidebar-title-item',
};
export const ExpandCollapseTriggers = {
    click: 'click',
    select: 'select',
};
export const SIDEBAR_SUBMENU_ANIMATION_TYPES = {
    OPENING: 'opening',
    CLOSING: 'closing',
    CLOSED: 'closed',
};
export const getCompoundDataHook = (baseDataHook, nestedDataHook) => baseDataHook ? `${baseDataHook}/${nestedDataHook}` : nestedDataHook;
//# sourceMappingURL=constants.js.map